import axiosConfig from './axiosConfig'

export const getTripHistoryList = page =>
  axiosConfig.get(
    `/web/api/appreservation/lists/?npp=10&page=${page}&task=immediacy`
  )

export const getTripHistoryDetail = orderId =>
  axiosConfig.get(`/web/api/appreservation/${orderId}/immediacy`)
